<template>
<!-- pc端 -->
<div class="forestry-page" v-if="isSmallScreen===false">
<headers :imageSrc="imageSrc"/>
<lin-mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<bottom/>
</div>
<!-- 移动端 -->
<div class="forestry-page" v-else>
<headers :imageSrc="imageSrc"/>
<fore-mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<bottom/>
</div>
</template>
<script>
import bottom from '@/components/bottom'
import headers from '../../components/headers.vue'
import ForeMains from '../../components/foreMains.vue'
import linMains from '../../components/lin-Mains.vue'
export default {
  components: { headers, bottom, ForeMains, linMains },
  data () {
    return {
      isSmallScreen: false,
      imageSrc: '../assets/image/lsjt_lyth.png',
      res1: '碳立方-绿色减碳-林业碳汇',
      res2: '林业碳汇是指利用森林的储碳功能，通过减少毁林，加强森林经营管理，植树造林，保护和恢复森林植被等活动，吸收和固定大气中的二氧化碳，并按照相关规则与碳汇交易相结合的过程，活动',
      res3: '或机制，具有碳汇价值，林业碳汇资产 (CCER) 可变成金融产品，在碳排放权交易市场交易，产生碳汇收益。',
      res4: '一：某林业集团碳资产管理项目  /  二：某市某区林业碳汇项目',
      res5: '../assets/2023logoImage/lythqjt.png'
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/lythbenner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/lythbenner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
